module.exports = __webpack_public_path__ + "img/portrait-078.5de3dba8.jpg";